// https://vuex.vuejs.org/en/mutations.html

export default {
  SetResellerContext (state, resellerId) {
    state.resellerContext = resellerId
  },
}
